import { useQueryParam, withRegisterSubmit } from '@psyomics/ui-common';
import { RegisterForm } from '@psyomics/ui-components';
import { useCallback, useMemo } from 'react';

import { getConfig } from '../config';
import { useOrganisationReferrerEmailDomainWhitelist } from '../features/self-hosted-register/hooks/use-organisation-referrer-email-domain-whitelist';

import { REFERRAL_REDIRECT_WHITELIST } from './redirect-whitelists';

const RegisterWithSubmit = withRegisterSubmit(RegisterForm, {
  defaultMethod: 'email',
  redirectWhitelist: REFERRAL_REDIRECT_WHITELIST,
});

const SelfHostedRegister = () => {
  const { referralApiUrl } = getConfig();
  const orgCode = useQueryParam('orgCode') ?? undefined;
  const redirect = useQueryParam('redirect') ?? undefined;
  const [allowedEmailDomains] = useOrganisationReferrerEmailDomainWhitelist(orgCode);

  const getAuthSessionContext = useCallback(
    () => ({
      orgCode,
    }),
    [orgCode]
  );

  const signInUrl = useMemo(() => {
    const params = new URLSearchParams();

    if (orgCode != null) {
      params.set('orgCode', orgCode);
    }

    if (redirect != null) {
      params.set('redirect', redirect);
    }

    const query = params.toString();
    return query ? `/login?${query}` : '/login';
  }, [orgCode, redirect]);

  return (
    <div className="w-full flex justify-center mt-8">
      <div className="w-full max-w-[327px] mx-[24px]">
        <RegisterWithSubmit
          allowedEmailDomains={allowedEmailDomains}
          apiUrl={referralApiUrl}
          getAuthSessionContext={getAuthSessionContext}
          headerKey="auth.register.referralPortal.mainHeader"
          showRegistrationMethodToggle={false}
          signInUrl={signInUrl}
          submitButtonKey="auth.register.referralPortal.submit"
        />
      </div>
    </div>
  );
};

export { SelfHostedRegister };
